import React, { useState, useEffect } from "react";
import "../Testing.css";
import CheckBox from "../../../Buttons/CheckBox";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import {
  getSuiteMode,
  getSuiteTestingState,
} from "../../../../redux/reducers/ModuleStateReducer";
import ToolsContentButton from "../../ToolsCommon/ToolsContentButton";
import { ESuiteMode, ETestingState } from "../../../../Model/ModuleState";
import TestingApi from "../../../../api/TestingApi";
import { ETestingType } from "../../../../Model/TestingParameter";

type Props = {
  imagerIdentifier: string;
};

export default function PlateBumpTest({ imagerIdentifier }: Props) {
  const suiteTesting = useTypedSelector((state) => getSuiteTestingState(state));
  const suiteMode = useTypedSelector((state) => getSuiteMode(state));
  const [status, setStatus] = useState("status....");
  const [useRandomPlate, setUseRandomPlate] = useState(false);
  const isDisabled = suiteMode !== ESuiteMode.Normal;
  const isRunningPlateBumpTest =
    suiteMode === ESuiteMode.Testing &&
    suiteTesting.plateBump?.state === ETestingState.Started;

  const runPlateBumpTest = () => {
    TestingApi.doTesting({
      moduleIdentifier: imagerIdentifier,
      type: ETestingType.PlateBump,
      plateBumpTest: {
        useRandomPlate: useRandomPlate,
      },
    });
  };

  const stopPlateBumpTest = () => {
    TestingApi.stopTesting();
  };

  useEffect(() => {
    if (suiteTesting.plateBump?.state === ETestingState.Started) {
      const counter = suiteTesting.plateBump.counter ?? 0;
      setStatus("Count :" + counter.toString());
    }
  }, [suiteTesting.plateBump?.counter]);

  return (
    <div className={"testing-content"}>
      <div className={"testing-card no-border"} style={{marginTop: 0}}>
        <div>Plate Bump Test</div>
        <CheckBox
          id="isRandomPlate"
          label="Random Plate"
          name="isRandomPlate"
          colorVariant="alternate"
          disabled={isDisabled}
          checked={useRandomPlate}
          onChange={() => setUseRandomPlate(!useRandomPlate)}
          style={{
            paddingTop: 5,
            fontSize: 13,
            marginTop: "20px",
            marginLeft: "15px",
          }}
        />
        <div className={"testing-button-group"}>
          <ToolsContentButton
            text="Stop"
            onClick={stopPlateBumpTest}
            disabled={!isRunningPlateBumpTest}
            variant="primary"
            colorVariant="black"
          />
           <ToolsContentButton
            text="run"
            onClick={runPlateBumpTest}
            disabled={isDisabled}
            variant="primary"
            colorVariant="default"
          />
        </div>
      </div>
      <div
        className={"testing-status-box"}
        style={{
          opacity: isDisabled ? 0.5 : 1,
        }}
      >
        <p>{status}</p>
      </div>
    </div>
  );
}
